import { useMessageSend } from '@/components/hooks/customs/addressBook/useMessageSend';
import { useMessageSender } from '@/components/hooks/customs/addressBook/useMessageSender';
import { useChargeStateHandler } from '@/components/hooks/customs/charge/chargeStation/useChargeStateHandler';
import { usePOBox015 } from '@/components/hooks/customs/say015/pobox015/usePOBox015';
import { TOpenModal } from '@/components/hooks/customs/useHotfixModal';
import SelectNumber from '@/components/softPhone/DisplayGroups/ServiceSignUp/SelectNumber/SelectNumber';
import {
  amountModalRecoil,
  OpenModalCallNumRecoil,
  OpenModalDataRecoil,
  openModalRecoil,
} from '@/recoil/atoms/modalRecoil';
import { softPhoneRowTabRecoil } from '@/recoil/atoms/router/mainRouterRecoil';
import { formatPhoneNumber } from '@/shared/util/format/phoneNumberFormatUtil';
import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';

import { useModalHook } from '@/components/commons/modals/useModalHook';
import { usePageCharge } from '@/components/hooks/customs/charge/chargeStation/useCharge';
import { WORKS015_ANNUAL, WORKS015_MONTHLY, WORKS015_PROMO1 } from '@/shared/constants';
import IconCheck from '@/styles/icons/IconCheck';
import { Spin } from 'antd';
import { BsArrowRight } from 'react-icons/bs';
import { IoClose } from 'react-icons/io5';
import * as S from './Event2Modal.style';
import Event3Modal from './Event3Modal';
import ModalChargeTop from './ModalChargeTop';
import { useNavigate } from 'react-router-dom';

interface IAuthorityData {
  availabilityStatus: boolean;
  monthlyPrice: number;
  number015: string;
  say015User: boolean;
  subsEndDate: string;
  subscriptionStatus: boolean;
}

interface IHotfixModal {
  onClickHotfixClose: (type: keyof TOpenModal, button?: '7days') => void;
}

const Event2Modal = (props: IHotfixModal) => {
  const navigate = useNavigate();
  const softPhoneRowTabState = useRecoilValue(softPhoneRowTabRecoil);
  const { selectNumber } = useMessageSender();
  const [callNumS, setCallNumS] = useRecoilState(OpenModalCallNumRecoil);

  //015 유저 상태
  const [userState, setUserState] = useState<'미가입' | '구독 만료' | '가입' | ''>('');

  // 010 일때 만들어질 새로운 컨펌창 상태값
  const [openModalS, setOpenModalS] = useRecoilState(openModalRecoil);
  // 010 일 때 컨펌창에 넘길 데이터
  const [openModalDataS, setOpenModalDataS] = useRecoilState(OpenModalDataRecoil);
  const resetOpenModalDataS = useResetRecoilState(OpenModalDataRecoil);

  // 정기결제 동의 구하는 이용약관 popup RECOIL
  const [amountModalS, setAmountModalS] = useRecoilState(amountModalRecoil);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  const { confirmModal, warningModal } = useModalHook();

  // 정기결제 동의 이용약관
  const onClickServiceTerms = () => {
    setAmountModalS(true);
  };
  const onCheckChange1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked1(e.target.checked);
  };
  const onCheckChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked2(e.target.checked);
  };

  //모달 닫기
  const onClickModal = () => {
    setOpenModalS(false);
    resetOpenModalDataS();
  };

  const hooks = useMessageSend({ selectNumber, fomatCallingNum: callNumS });

  // 1. 메세지 버튼 눌렸을 때 010 인지 015 인지 판단
  const onClickMessageButton = (type: '010' | '015' | '') => {
    if (openModalDataS.pointEnough) {
      setCallNumS(type);
    } else {
      setOpenModalS(false);
      confirmModal(
        async () => {
          navigate('/charge');
        },
        '전송 실패',
        `캐시가 부족합니다. 충전소로 이동할까요?`,
        true,
      );
    }
  };

  // 2. 판단 후 발송
  useEffect(() => {
    userState && callNumS && hooks.onClickSend(Number(softPhoneRowTabState), userState);
  }, [callNumS]);

  // 015유저 구독 만료랑 만기 확인 하는 훅
  const { authorityData, authorityDataRefetch } = usePOBox015();

  useEffect(() => {
    if (authorityData && authorityData?.say015User === false) {
      setUserState('미가입');
    } else if (authorityData?.say015User === true && authorityData?.availabilityStatus === false) {
      setUserState('구독 만료');
    } else {
      setUserState('가입');
    }
  }, [authorityData]);

  const freeMsgInfo = { type: 'SMS', freeCount: 0, remainingFreeCount: 0 };
  switch (openModalDataS.usrCd) {
    case '00000':
      freeMsgInfo.type = 'SMS';
      freeMsgInfo.freeCount = openModalDataS.freeSmsCount;
      freeMsgInfo.remainingFreeCount = openModalDataS.freeSmsCountAfterCharge;
      break;
    case 'LMS01':
      freeMsgInfo.type = 'LMS';
      // freeMsgInfo.freeCount = openModalDataS.freeLmsCount;
      // freeMsgInfo.remainingFreeCount = openModalDataS.freeLmsCountAfterCharge;
      freeMsgInfo.freeCount = openModalDataS.freeSmsCount;
      freeMsgInfo.remainingFreeCount = openModalDataS.freeSmsCountAfterCharge;
      break;
    case 'MMS01':
      freeMsgInfo.type = 'MMS';
      // freeMsgInfo.freeCount = openModalDataS.freeMmsCount;
      // freeMsgInfo.remainingFreeCount = openModalDataS.freeMmsCountAfterCharge;
      freeMsgInfo.freeCount = openModalDataS.freeSmsCount;
      freeMsgInfo.remainingFreeCount = openModalDataS.freeSmsCountAfterCharge;
      break;
    default:
      break;
  }

  // useEffect(() => {
  //   if (authorityData) {
  //     const initailAuthorityData = {
  //       availabilityStatus: authorityData?.availabilityStatus,
  //       monthlyPrice: authorityData?.monthlyPrice,
  //       number015: authorityData?.number015,
  //       say015User: authorityData?.say015User,
  //       subsEndDate: authorityData?.subsEndDate,
  //       subscriptionStatus: authorityData?.subscriptionStatus,
  //     };
  //   }
  // }, [authorityData]);

  const chargeHooks = useChargeStateHandler();

  // 월간가격
  const monthlyPrice = parseInt(WORKS015_MONTHLY as string, 10);
  // 연간가격
  const annualPrice = parseInt(WORKS015_ANNUAL as string, 10);
  // 결제 API HOOK
  const chargePayHooks = usePageCharge({ returnUrl: 'EasyComponent' });

  return (
    <>
      {amountModalS && <Event3Modal />}
      {openModalDataS && (
        <>
          <S.Overlay />

          <S.EventModalWrap>
            <S.ModalHeader>
              <S.Circle />
              {!hooks.sendMsgLoading && (
                <S.CloseButtonBox
                  onClick={() => {
                    onClickModal();
                  }}
                >
                  <IoClose />
                </S.CloseButtonBox>
              )}
            </S.ModalHeader>

            <S.Content>
              <h3>
                <strong>{freeMsgInfo.type}</strong>로 전송하시겠습니까?
              </h3>

              <div>
                <p>
                  <strong>발신 번호</strong> : {formatPhoneNumber(openModalDataS.callback)}
                </p>
                <p>
                  <strong>수신 인원</strong> : {openModalDataS.totalReceivers} 명
                </p>

                <S.DashedLine />

                <S.ModalButtonContainer>
                  {hooks.sendMsgLoading ? (
                    <button style={{ backgroundColor: 'white' }}>
                      <Spin size="default" />
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          hooks.clockToggleS
                            ? warningModal('예약 전송', '현재 015 예약 전송은 서비스 준비중에 있습니다.', true)
                            : onClickMessageButton('015');
                        }}
                      >
                        {/* <strong>
                          {openModalDataS.totalCost &&
                            openModalDataS.totalCostFor015 !== undefined &&
                            Math.round(
                              ((openModalDataS.totalCost - openModalDataS.totalCostFor015) / openModalDataS.totalCost) *
                                100,
                            )}
                        </strong> */}
                        015 전송하기 (
                        {openModalDataS.totalCostFor015 && openModalDataS.totalCostFor015.toLocaleString('ko-KR')}원)
                      </button>

                      <button
                        onClick={() => {
                          onClickMessageButton('010');
                        }}
                      >
                        010 전송하기({openModalDataS.totalCost.toLocaleString('ko-KR')} 원)
                      </button>
                    </>
                  )}
                </S.ModalButtonContainer>
              </div>
            </S.Content>

            {userState !== '가입' && (
              <>
                <S.DashedLine />
                <S.DashedLine />
              </>
            )}

            {userState === '미가입' && <SelectNumber authorityDataRefetch={authorityDataRefetch} authorityDataState />}

            {userState === '구독 만료' && (
              <div
                style={{
                  padding: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '2rem',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                }}
              >
                <h3 style={{ fontSize: '2.4rem', fontWeight: '800' }}>015 통신료 결제</h3>
                <ModalChargeTop
                  handlerPayMethodTypes={chargeHooks.handlerPayMethodTypes}
                  payMethodTypeCodeState={chargeHooks.payMethodTypeCodeState.payMethodTypeCode}
                />
                <S.CardContainer>
                  <S.Card>
                    <S.Header>
                      <h3>월간</h3>
                      <p>1개월의 통신료 결제</p>
                    </S.Header>
                    <S.Main>
                      <div>
                        <strong>1,100</strong>원
                      </div>
                      <span>VAT 포함</span>
                    </S.Main>

                    <S.ButtonWrap>
                      <S.Button
                        onClick={() =>
                          chargePayHooks.onChargeApi({
                            // amount: props.productType === 'monthly_pass' ? monthlyPrice : annualPrice,
                            amount: monthlyPrice,
                            payMethodTypeCode: chargeHooks.payMethodTypeCodeState.payMethodTypeCode,
                            productType: 'monthly_pass',
                            returnUrl: 'EasyComponent',
                          })
                        }
                      >
                        결제 하기
                      </S.Button>
                      <div className="checkbox">
                        {/* <input type="checkbox" id="service-confirm1" checked={isChecked1} onChange={onCheckChange1} /> */}
                        <label htmlFor="service-confirm1">구독 자동결제</label>
                        <div className="service-view" onClick={() => onClickServiceTerms()}>
                          [약관보기]
                        </div>
                      </div>
                    </S.ButtonWrap>

                    <S.CheckContainer>
                      <S.Check>
                        <IconCheck fontSize={'2rem'} /> 음성 사서함 무제한 이용
                      </S.Check>
                      <S.Check>
                        <IconCheck fontSize={'2rem'} /> SMS 발송 매월 {WORKS015_PROMO1}건 제공
                      </S.Check>
                    </S.CheckContainer>
                  </S.Card>

                  <S.Card>
                    <S.Header>
                      <h3>연간</h3>
                      <p>12개월의 통신료 결제</p>
                    </S.Header>
                    <S.Main>
                      <div>
                        <strong>11,000</strong>원
                      </div>
                      <span>VAT 포함</span>
                    </S.Main>

                    <S.ButtonWrap>
                      <S.Button
                        onClick={() =>
                          chargePayHooks.onChargeApi({
                            amount: annualPrice,
                            payMethodTypeCode: chargeHooks.payMethodTypeCodeState.payMethodTypeCode,
                            productType: 'annual_pass',
                            returnUrl: 'EasyComponent',
                          })
                        }
                      >
                        결제 하기
                      </S.Button>
                      <div className="checkbox">
                        {/* <input type="checkbox" id="service-confirm2" checked={isChecked2} onChange={onCheckChange2} /> */}
                        <label htmlFor="service-confirm2">구독 자동결제</label>
                        <div className="service-view" onClick={() => onClickServiceTerms()}>
                          [약관보기]
                        </div>
                      </div>
                    </S.ButtonWrap>

                    <S.CheckContainer>
                      <S.Check>
                        <IconCheck fontSize={'2rem'} /> 17% 할인
                      </S.Check>

                      <S.Check>
                        <IconCheck fontSize={'2rem'} /> 음성사서함 무제한 이용
                      </S.Check>
                    </S.CheckContainer>
                  </S.Card>
                </S.CardContainer>
              </div>
            )}
          </S.EventModalWrap>
        </>
      )}
    </>
  );
};

export default Event2Modal;
